import { createContext, ReactNode, useCallback, useMemo } from 'react';
import {
  ERRORS_TEMPLATES,
  isErrorTemplate,
} from '@/utils/errorMessageValidation';
import { fetchData } from '@/utils';
import useError from '@/hooks/useError';

type Props = {
  children: ReactNode;
};

type SmsVerification = { body: { code: string } };

export type ConfirmationContextType = {
  sendCode: ({ body }: SmsVerification) => Promise<void>;
};

export const ConfirmationContext = createContext<ConfirmationContextType>(
  {} as ConfirmationContextType,
);

export function ConfirmationProvider({ children }: Props): React.JSX.Element {
  const { showError } = useError();

  const sendCode = useCallback(
    async ({ body }: SmsVerification) => {
      try {
        const data = await fetchData('/client/application/verify-code', {
          method: 'post',
          body: JSON.stringify(body),
        });

        return data;
      } catch (e) {
        if (!isErrorTemplate(e, ERRORS_TEMPLATES.INCORRECT_CODE)) {
          showError();
        }
        throw e;
      }
    },
    [showError],
  );

  const ConfirmationContextValue = useMemo(() => {
    return {
      sendCode,
    };
  }, [sendCode]);

  return (
    <ConfirmationContext.Provider value={ConfirmationContextValue}>
      {children}
    </ConfirmationContext.Provider>
  );
}
